(function () {
    'use strict';

    /**
    * @memberof app
    * @ngdoc controller
    * @name OraculusController
    * @description
    * Controller for the IA Chat modal
    **/

    angular
        .module('appback')
        .controller('OraculusController', OraculusController);

    OraculusController.$inject = ['OraculusService', 'AnalisisService', '$timeout', '$scope', '$uibModalInstance', 'peticion_id', 'lims_id', 'animal', 'tipo_peticion', 'initial_data', 'rc'];

    function OraculusController(OraculusService, AnalisisService, $timeout, $scope, $uibModalInstance, peticion_id, lims_id, animal, tipo_peticion, initial_data, rc) {
        $scope.step = 1;
        $scope.rc = rc;
        $scope.leishmaniaInfo = {};
        $scope.peticion_id = peticion_id;
        $scope.animal_id = animal ? animal.id : false;
        $scope.requests = []; //peticiones del mismo animal
        $scope.animal = {};
        $scope.data = {
            comentario: "",
        };
        $scope.selectedFiles = [];
        $scope.peticiones_chat = []; //peticiones incluidas en el mismo chat
        $scope.promps = [];
        $scope.mensajes_restantes = 3;
        $scope.iachat_id = false;
        $scope.isStreaming = false;

        // Scroll to bottom function
        $scope.scrollTopToBottom = function () {
            setTimeout(function () {
                var $chatBody = $('#oraculusChatBody');
                if ($chatBody.length) {
                    $chatBody.stop().animate({
                        scrollTop: $chatBody[0].scrollHeight
                    }, 500);
                }
            }, 100);
        }

        // Reusable function to handle IA streaming responses
        $scope.handleStream = function (serviceCall, onCompleteExtra) {
            $scope.isStreaming = true;

            var tempMessage = {
                role: 'assistant',
                contenido: '',
                streaming: true
            };

            if (!$scope.promps) $scope.promps = [];
            $scope.promps.push(tempMessage);

            var textQueue = [];
            var isProcessingQueue = false;

            function processQueue() {
                if (textQueue.length > 0) {
                    isProcessingQueue = true;
                    var chunk = textQueue.shift();
                    $scope.$apply(function () {
                        tempMessage.contenido += chunk;
                        $scope.scrollTopToBottom();
                    });
                    setTimeout(processQueue, 25);
                } else {
                    isProcessingQueue = false;
                }
            }

            $scope.streamController = serviceCall(
                function (chunk) {
                    textQueue.push(chunk);
                    if (!isProcessingQueue) processQueue();
                },
                function () {
                    var checkFinish = setInterval(function () {
                        if (textQueue.length === 0) {
                            clearInterval(checkFinish);
                            $scope.$apply(function () {
                                tempMessage.streaming = false;
                                $scope.isStreaming = false;
                                if (onCompleteExtra) onCompleteExtra();
                            });
                        }
                    }, 100);
                },
                function (error) {
                    $scope.$apply(function () {
                        tempMessage.contenido += '\n[Error: ' + error + ']';
                        tempMessage.streaming = false;
                        $scope.isStreaming = false;
                    });
                },
                function (iachat_id) {
                    console.log("iachat_id recibido", iachat_id);
                    $scope.iachat_id = iachat_id;
                }
            );
        };

        if (initial_data.iachat_id) {
            $scope.promps = initial_data.promps;
            $scope.mensajes_restantes = initial_data.mensajes_restantes;
            $scope.peticiones_chat = initial_data.peticiones_chat;
            $scope.step = 3;
            $scope.iachat_id = initial_data.iachat_id;
            $timeout(function () {
                $scope.scrollTopToBottom();
            })
        }

        // Navigate to specific step
        $scope.goToStep = function (step) {
            $scope.step = step;
        };

        // Step 1: Select mode (single or multiple)
        $scope.selectMode = function (mode) {
            if (mode === 'single') {
                $scope.loadChatDataStream();
            } else {
                if (!$scope.animal_id) return;
                $scope.loadPeticiones();
            }
        };

        $scope.filtros_peticiones = { tipo: 'Lab' };
        $scope.selectedRequests = {
            'Lab': [],
            'In': [],
            'Sm': []
        };

        // Load peticiones for step 2
        $scope.loadPeticiones = function (tipo) {
            if (tipo) $scope.filtros_peticiones.tipo = tipo;
            AnalisisService.getPeticionesAnimal($scope.animal_id, $scope.filtros_peticiones.tipo, function (data) {
                $scope.requests = data.muestras.filter(function (request) {
                    return request.id != peticion_id;
                }).map(function (request) {
                    request.selected = $scope.selectedRequests[$scope.filtros_peticiones.tipo].some(function (r) { return r.id === request.id; });
                    return request;
                });
                if (data.animal) {
                    $scope.animal = data.animal;
                }
                $scope.step = 2;
            });
        };

        // Check if there are any selections in any category
        $scope.hasSelections = function () {
            for (var tipo in $scope.selectedRequests) {
                if ($scope.selectedRequests[tipo].length > 0) {
                    return true;
                }
            }
            return false;
        };

        // Sync request selection with the selectedRequests object
        $scope.toggleSelection = function (req) {
            var tipo = $scope.filtros_peticiones.tipo;
            var index = $scope.selectedRequests[tipo].findIndex(function (r) { return r.id === req.id; });

            if (req.selected) {
                if (index === -1) {
                    $scope.selectedRequests[tipo].push({ id: req.id, lims_id: req.lims_id });
                }
            } else {
                if (index > -1) {
                    $scope.selectedRequests[tipo].splice(index, 1);
                }
            }
        };

        // Continue to chat from step 2
        $scope.continueToChat = function () {
            $scope.loadChatDataStream();
        };

        $scope.getLeishmania = function () {
            AnalisisService.getLeishmania(peticion_id, function (data) {
                $scope.leishmaniaInfo = data;
            });
        }
        // Load chat data with streaming
        $scope.loadChatDataStream = function () {
            $scope.step = 3;
            if (!$scope.selectedRequests[tipo_peticion]) $scope.selectedRequests[tipo_peticion] = [];
            $scope.selectedRequests[tipo_peticion].push({ id: peticion_id, lims_id: lims_id });
            $scope.handleStream(function (onChunk, onComplete, onError, onChatId) {

                return OraculusService.newChatStream($scope.selectedRequests, $scope.rc.peticion.centro.idioma_code, onChunk, onComplete, onError, onChatId);
            },
                function () {
                    OraculusService.getIaChat(peticion_id, tipo_peticion, true, function (data) {
                        $scope.promps = data.promps;
                        $scope.mensajes_restantes = data.mensajes_restantes;
                        $scope.peticiones_chat = data.peticiones_chat;
                        $scope.step = 3;
                        $scope.iachat_id = data.iachat_id;
                        $timeout(function () {
                            $scope.scrollTopToBottom();
                        })
                    });
                });
        };

        $scope.sendToIAStream = function () {
            if (!$scope.data.comentario && $scope.selectedFiles.length === 0) return;

            var mensajeParaEnviar = $scope.data.comentario;
            var filesParaEnviar = $scope.selectedFiles;

            var userPromp = {
                role: 'user',
                contenido: mensajeParaEnviar,
                extra: { adjuntos: [] }
            };

            $scope.promps.push(userPromp);
            $scope.scrollTopToBottom();

            $scope.data.comentario = "";
            $scope.clearSelectedFiles();

            $scope.handleStream(
                function (onChunk, onComplete, onError, onChatId) {
                    return OraculusService.setComentarioStream($scope.iachat_id, mensajeParaEnviar, onChunk, onComplete, onError, onChatId, filesParaEnviar);
                },
                function () {
                    OraculusService.getIaChat(peticion_id, tipo_peticion, true, function (data) {
                        $scope.promps = data.promps;
                        $scope.mensajes_restantes = data.mensajes_restantes;
                    });
                }
            );
        }

        // Trigger file input click
        $scope.triggerFileInput = function () {
            document.getElementById('oraculus-file-input').click();
        };

        // Handle file selection (multiple)
        $scope.onFileChange = function (element) {
            $scope.$apply(function () {
                if (element.files && element.files.length > 0) {
                    var allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

                    for (var i = 0; i < element.files.length; i++) {
                        var file = element.files[i];

                        // Validate file type
                        if (allowedTypes.indexOf(file.type) === -1) {
                            alert('El archivo "' + file.name + '" no es válido. Solo se permiten imágenes y PDFs.');
                            continue;
                        }

                        // Avoid duplicates by name and size
                        var exists = $scope.selectedFiles.some(function (f) {
                            return f.name === file.name && f.size === file.size;
                        });

                        if (!exists) {
                            $scope.selectedFiles.push(file);
                        }
                    }
                    element.value = '';
                }
            });
        };

        // Remove specific file from list
        $scope.removeSelectedFile = function (index) {
            $scope.selectedFiles.splice(index, 1);
        };

        // Clear all files
        $scope.clearSelectedFiles = function () {
            $scope.selectedFiles = [];
        };

        // Close modal
        $scope.okForm = function () {
            $uibModalInstance.close();
        };

        $scope.koForm = function () {
            $uibModalInstance.dismiss();
        };
    }
})();
